module.exports = "https://static.wmbcdn.com/uniweb/images/fce2b7d557d06bed2eba751d433ec29a.svg";